<template>
  <div class="flex-row headerWrap">
    <div class="fxVer logo">
      <router-link to="/" class="link">
        <img src="@/assets/img/logo.png" alt="" />
      </router-link>
    </div>

    <div class="fs16" v-if="envLabel">{{ envLabel }}</div>

    <div class="fdr language">
      <div class="mr46">
        <a :href="getLanguage == 'zh' ? 'http://www.estarbizadvisor.com/' : 'http://en.estarbizadvisor.com/'" target="_" class="fxRow">
          <img src="@/assets/img/icon/home.png" alt="" />
          <p class="fs14 ml6">{{ $t("common.official") }}</p>
        </a>
      </div>

      <el-dropdown trigger="click" @command="handleCommand">
        <span class="crp">
          <i class="tagIcon">{{ getLanguage == "zh" ? "CN" : "EN" }}</i>
          {{ $t("common.language") }}
          <i class="vam el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown" class="languageWrap">
          <el-dropdown-item command="zh" :class="getLanguage == 'zh' ? 'activeLg' : ''">中文</el-dropdown-item>
          <el-dropdown-item command="en" :class="getLanguage == 'en' ? 'activeLg' : ''">English</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Forget",
  data() {
    return {};
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
    envLabel() {
      return process.env.VUE_APP_ENV_LABEL || "";
    },
  },
  methods: {
    ...mapActions("language", ["switchLanguage"]),
    handleCommand(command) {
      // 避免重复切换语言
      if (command != this.getLanguage) {
        this.switchLanguage(command);
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.headerWrap {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 86px;
  line-height: 86px;
  padding: 0 30px;
  justify-content: space-between;
}

.logo img {
  height: 50px;
}

.activeLg {
  color: #66b1ff;
}

.language {
  ::v-deep {
    .el-dropdown {
      display: block;
    }

    .el-icon-arrow-down {
      font-weight: 800;
      color: #7a89a1;
      opacity: 0.5;
      margin-left: 0px;
    }
  }
}

.languageWrap {
  ::v-deep {
    .el-dropdown-menu__item {
      white-space: nowrap;
      text-align: center;
    }
  }
}

.tagIcon {
  display: inline-block;
  width: 22px;
  text-align: center;
  height: 20px;
  line-height: 20px;
  background: #011a45;
  opacity: 0.5;
  border-radius: 4px;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  margin-right: 8px;
}
</style>
